import { render, staticRenderFns } from "./Paiement.vue?vue&type=template&id=2bc6792f&"
import script from "./Paiement.vue?vue&type=script&lang=ts&"
export * from "./Paiement.vue?vue&type=script&lang=ts&"
import style0 from "./Paiement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports